import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'
import 'vuetify/dist/vuetify.min.css'
import '~/plugins'
import '~/components'
import Vuetify from 'vuetify'
import { abilitiesPlugin } from '@casl/vue'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)
Vue.use(abilitiesPlugin)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js